import gql from 'graphql-tag';

export const FEEDBACK_MUTATION = gql`
    mutation sendFeedback($feedback: FeedBackRequestInput!) {
        sendFeedback(feedback: $feedback)
    }
`;
